function normalizePathSegment(value) {
    if (!value) {
        return 'default'
    }

    const normalizedValue = String(value).trim()

    return normalizedValue ? encodeURIComponent(normalizedValue) : 'default'
}

function normalizeArticleCode(article) {
    const code = article?.code || article?.slug || ''

    return code ? encodeURIComponent(String(code).trim()) : ''
}

// Единая нормализация ЧПУ статьи с fallback для пустых сегментов.
export function buildArticleRoute(article = {}) {
    const category = normalizePathSegment(article.category)
    const subcategory = normalizePathSegment(article.subcategory)
    const code = normalizeArticleCode(article)

    return `/${category}/${subcategory}/${code}`
}

export function getArticleRouteCode(routeParams = {}) {
    return routeParams.code || ''
}